import { getToolName, isToolUIPart, type UIMessage } from 'ai';

export type BagelChatMessagePart = NonNullable<UIMessage['parts']>[number];

export function isBagelToolPart(part: BagelChatMessagePart): boolean {
  const partType = (part as { type: string }).type;
  return isToolUIPart(part as never) || partType === 'dynamic-tool';
}

export function getBagelToolName(part: BagelChatMessagePart): string | null {
  if (!isBagelToolPart(part)) return null;
  if ((part as { type: string }).type === 'dynamic-tool') {
    return (part as { toolName: string }).toolName;
  }
  return getToolName(part as never);
}

export function isBagelToolInProgress(part: BagelChatMessagePart): boolean {
  if (!isBagelToolPart(part)) return false;
  const { state } = part as { state?: string };
  return (
    state === 'input-streaming' ||
    state === 'input-available' ||
    state === 'approval-requested'
  );
}

export function getBagelToolOutput(part: BagelChatMessagePart): unknown {
  if (!isBagelToolPart(part)) return undefined;
  const toolPart = part as { state?: string; output?: unknown };
  if (toolPart.state === 'output-available') return toolPart.output;
  return undefined;
}
